import { render, staticRenderFns } from "./BattleListFooter.vue?vue&type=template&id=7dfb1fe8&scoped=true&"
import script from "./BattleListFooter.vue?vue&type=script&lang=ts&"
export * from "./BattleListFooter.vue?vue&type=script&lang=ts&"
import style0 from "./BattleListFooter.vue?vue&type=style&index=0&id=7dfb1fe8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dfb1fe8",
  null
  
)

export default component.exports